// extracted by mini-css-extract-plugin
export default {"hideTooltip":"z--z","fadeIn":"A--z","delay":"B--z","recommendedSizeTooltip":"C--z"};